import { SpecificEntityGroupTree } from '../TreeLeaves/Admin/AdminEntitiesTrees';
import { SpecificDeviceVisibleGroupTree } from '../TreeLeaves/VisibleDeviceGroupsTree';
import { SpecificVisibleGroupTree } from '../TreeLeaves/VisibleGroupsTree';
import { SpecificDeviceGroupTree } from '../TreeLeaves/Admin/AdminDevicesTrees';
export const generateEntityDomainTreeDef = (domain, objectTypeId, visibility, name, uniqueTreeId) => {
    let treeFC = null;
    switch (visibility) {
        case 'user':
            treeFC = SpecificVisibleGroupTree(objectTypeId, uniqueTreeId ?? visibility, name, domain);
            break;
        case 'admin':
            treeFC = SpecificEntityGroupTree(objectTypeId, uniqueTreeId ?? visibility, name, domain);
            break;
    }
    // don't set a label, because then we get to omit the awkward intermediary folder that serves no use or purpose
    return { treeFC };
};
export const generateDeviceDomainTreeDef = (domain, deviceType, visibility) => {
    let treeFC = null;
    switch (visibility) {
        case 'user':
            treeFC = SpecificDeviceVisibleGroupTree(deviceType, domain, visibility);
            break;
        case 'admin':
            treeFC = SpecificDeviceGroupTree(deviceType, domain, visibility);
            break;
    }
    // don't set a label, because then we get to omit the awkward intermediary folder that serves no use or purpose
    return { treeFC };
};
